module.exports = __webpack_public_path__ + "static/elder-brain-mtg_clb-2d6516b0a4040683fd109b701ffb4593.jpg";